module.exports = __webpack_public_path__ + "img/user-face.55b99d1c.jpg";